import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Table,
  Badge,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import CommonHeader from "components/Headers/CommonHeader.js";
import CustomDropdown from "components/Common/CustomDropdown";
import CustomPagination from "components/Common/CustomPagination";
import LoadingDots from "components/Common/LoadingDots";
import Swal from "sweetalert2";
import {
  FaDollarSign,
  FaCreditCard,
  FaCalendarCheck,
  FaFileInvoiceDollar,
  FaSearch,
  FaEye,
  FaReceipt,
  FaCrown,
  FaDownload,
  FaExchangeAlt,
} from "react-icons/fa";

const ITEMS_PER_PAGE = 8;

const DUMMY_TRANSACTIONS = [
  {
    id: "TXN-9021",
    user: {
      name: "Kenji Sato",
      email: "kenji.sato@localmate.com",
      role: "Local Guide",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&auto=format&fit=crop&q=60",
      city: "Tokyo",
    },
    revenueType: "Guide Annual Subscription",
    planName: "Annual Guide Plan ($99.99/yr)",
    amount: 99.99,
    platformFee: 0.0,
    netEarnings: 99.99,
    paymentMethod: "Stripe •••• 4242",
    status: "completed",
    date: "2026-09-02 14:22",
    invoiceNumber: "INV-LM-2026-00129",
  },
  {
    id: "TXN-9022",
    user: {
      name: "Amélie Laurent",
      email: "amelie.laurent@localmate.com",
      role: "Local Guide",
      avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=100&auto=format&fit=crop&q=60",
      city: "Paris",
    },
    revenueType: "Guide Monthly Subscription",
    planName: "Monthly Guide Plan ($9.99/mo)",
    amount: 9.99,
    platformFee: 0.0,
    netEarnings: 9.99,
    paymentMethod: "Apple Pay",
    status: "completed",
    date: "2026-09-02 16:45",
    invoiceNumber: "INV-LM-2026-00130",
  },
  {
    id: "TXN-9023",
    user: {
      name: "Alex Johnson",
      email: "alex.j@example.com",
      role: "Traveler",
      avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&auto=format&fit=crop&q=60",
      city: "New York",
    },
    revenueType: "Direct Tour Payment",
    planName: "Tokyo Nightlife & Hidden Bars (4 hrs @ $45/hr)",
    amount: 180.0,
    platformFee: 18.0,
    netEarnings: 162.0,
    paymentMethod: "Visa •••• 8821",
    status: "completed",
    date: "2026-09-02 18:10",
    invoiceNumber: "INV-LM-2026-00131",
  },
  {
    id: "TXN-9024",
    user: {
      name: "Matteo Romano",
      email: "matteo.romano@localmate.com",
      role: "Local Guide",
      avatar: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&auto=format&fit=crop&q=60",
      city: "Rome",
    },
    revenueType: "Featured Guide Placement",
    planName: "Rome Top Destination Spotlight (30 Days)",
    amount: 29.99,
    platformFee: 0.0,
    netEarnings: 29.99,
    paymentMethod: "Mastercard •••• 5120",
    status: "completed",
    date: "2026-09-01 11:30",
    invoiceNumber: "INV-LM-2026-00132",
  },
  {
    id: "TXN-9025",
    user: {
      name: "Le Petit Bistro Paris",
      email: "contact@lepetitbistro.fr",
      role: "Local Business Advertiser",
      avatar: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=100&auto=format&fit=crop&q=60",
      city: "Paris",
    },
    revenueType: "Local Business Advertising",
    planName: "Sponsored Recommendation in Paris Guide Hub",
    amount: 99.0,
    platformFee: 0.0,
    netEarnings: 99.0,
    paymentMethod: "Bank Wire Transfer",
    status: "completed",
    date: "2026-08-31 09:15",
    invoiceNumber: "INV-LM-2026-00133",
  },
  {
    id: "TXN-9026",
    user: {
      name: "Sofia Mendez",
      email: "sofia.mendez@localmate.com",
      role: "Local Guide",
      avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&auto=format&fit=crop&q=60",
      city: "Barcelona",
    },
    revenueType: "Verified Pro Badge Upgrade",
    planName: "Verified Pro Guide Certification Badge",
    amount: 19.99,
    platformFee: 0.0,
    netEarnings: 19.99,
    paymentMethod: "PayPal",
    status: "completed",
    date: "2026-08-30 15:40",
    invoiceNumber: "INV-LM-2026-00134",
  },
  {
    id: "TXN-9027",
    user: {
      name: "Liam Wong",
      email: "liam.wong@example.com",
      role: "Traveler",
      avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&auto=format&fit=crop&q=60",
      city: "Toronto",
    },
    revenueType: "Travel Insurance Addon",
    planName: "Global Trip Shield with Allianz",
    amount: 5.0,
    platformFee: 2.0,
    netEarnings: 3.0,
    paymentMethod: "Google Pay",
    status: "completed",
    date: "2026-08-29 12:00",
    invoiceNumber: "INV-LM-2026-00135",
  },
  {
    id: "TXN-9028",
    user: {
      name: "Carlos Silva",
      email: "carlos.silva@localmate.com",
      role: "Local Guide",
      avatar: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=100&auto=format&fit=crop&q=60",
      city: "Rio de Janeiro",
    },
    revenueType: "Guide Monthly Subscription",
    planName: "Monthly Guide Plan ($9.99/mo)",
    amount: 9.99,
    platformFee: 0.0,
    netEarnings: 9.99,
    paymentMethod: "Stripe •••• 1190",
    status: "refunded",
    date: "2026-08-28 08:30",
    invoiceNumber: "INV-LM-2026-00136",
  },
];

const PaymentsRevenue = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [typeFilter, setTypeFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedTxn, setSelectedTxn] = useState(null);
  const [receiptModalOpen, setReceiptModalOpen] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setTransactions(DUMMY_TRANSACTIONS);
      setLoading(false);
    }, 400);
    return () => clearTimeout(timer);
  }, []);

  const filteredTransactions = transactions.filter((t) => {
    const matchesSearch =
      t.user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      t.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
      t.invoiceNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
      t.planName.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesType =
      typeFilter === "all" ? true : t.revenueType.toLowerCase().includes(typeFilter.toLowerCase());

    const matchesStatus =
      statusFilter === "all" ? true : t.status.toLowerCase() === statusFilter.toLowerCase();

    return matchesSearch && matchesType && matchesStatus;
  });

  const totalPages = Math.ceil(filteredTransactions.length / ITEMS_PER_PAGE) || 1;
  const paginatedTransactions = filteredTransactions.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleDownloadInvoice = (invoiceNo) => {
    Swal.fire({
      title: "Generating Tax Invoice",
      text: `PDF invoice for ${invoiceNo} downloaded.`,
      icon: "success",
      timer: 2000,
      showConfirmButton: false,
    });
  };

  return (
    <>
      <CommonHeader />
      <Container className="mt--7" fluid>
        {/* Revenue Cards */}
        <Row className="mb-4">
          <Col lg="3" md="6">
            <Card
              className="card-stats mb-4 mb-xl-0 shadow-sm border-0"
              role="button"
              tabIndex={0}
              onClick={() => {
                setTypeFilter("all");
                setCurrentPage(1);
              }}
              style={{
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                border:
                  typeFilter === "all"
                    ? "2px solid #2dce89"
                    : "1px solid transparent",
                transform: typeFilter === "all" ? "translateY(-3px)" : "none",
              }}
            >
              <CardBody>
                <Row>
                  <div className="col">
                    <h5 className="text-uppercase text-muted mb-0 font-weight-bold">
                      Gross Platform Revenue
                    </h5>
                    <span className="h2 font-weight-bold mb-0">$148,250</span>
                  </div>
                  <Col className="col-auto">
                    <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                      <FaDollarSign />
                    </div>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-muted text-sm">
                  <span className="text-success mr-2 font-weight-bold">+24.5%</span>
                  <span>vs last month</span>
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col lg="3" md="6">
            <Card
              className="card-stats mb-4 mb-xl-0 shadow-sm border-0"
              role="button"
              tabIndex={0}
              onClick={() => {
                setTypeFilter("subscription");
                setCurrentPage(1);
              }}
              style={{
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                border:
                  typeFilter === "subscription"
                    ? "2px solid #5e72e4"
                    : "1px solid transparent",
                transform:
                  typeFilter === "subscription" ? "translateY(-3px)" : "none",
              }}
            >
              <CardBody>
                <Row>
                  <div className="col">
                    <h5 className="text-uppercase text-muted mb-0 font-weight-bold">
                      Guide Subscription MRR
                    </h5>
                    <span className="h2 font-weight-bold mb-0">$18,450</span>
                  </div>
                  <Col className="col-auto">
                    <div className="icon icon-shape bg-primary text-white rounded-circle shadow">
                      <FaCrown />
                    </div>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-muted text-sm">
                  <span className="text-primary mr-2 font-weight-bold">1,240 Guides</span>
                  <span>Active Subscribers</span>
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col lg="3" md="6">
            <Card
              className="card-stats mb-4 mb-xl-0 shadow-sm border-0"
              role="button"
              tabIndex={0}
              onClick={() => {
                setTypeFilter("featured");
                setCurrentPage(1);
              }}
              style={{
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                border:
                  typeFilter === "featured"
                    ? "2px solid #fb6340"
                    : "1px solid transparent",
                transform:
                  typeFilter === "featured" ? "translateY(-3px)" : "none",
              }}
            >
              <CardBody>
                <Row>
                  <div className="col">
                    <h5 className="text-uppercase text-muted mb-0 font-weight-bold">
                      Featured & Ads Revenue
                    </h5>
                    <span className="h2 font-weight-bold mb-0">$6,890</span>
                  </div>
                  <Col className="col-auto">
                    <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                      <FaFileInvoiceDollar />
                    </div>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-muted text-sm">
                  <span className="text-success mr-2 font-weight-bold">+12%</span>
                  <span>Local biz partners</span>
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col lg="3" md="6">
            <Card
              className="card-stats mb-4 mb-xl-0 shadow-sm border-0"
              role="button"
              tabIndex={0}
              onClick={() => {
                setTypeFilter("direct");
                setCurrentPage(1);
              }}
              style={{
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                border:
                  typeFilter === "direct"
                    ? "2px solid #11cdef"
                    : "1px solid transparent",
                transform:
                  typeFilter === "direct" ? "translateY(-3px)" : "none",
              }}
            >
              <CardBody>
                <Row>
                  <div className="col">
                    <h5 className="text-uppercase text-muted mb-0 font-weight-bold">
                      Direct Tour Payouts
                    </h5>
                    <span className="h2 font-weight-bold mb-0">$84,920</span>
                  </div>
                  <Col className="col-auto">
                    <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                      <FaExchangeAlt />
                    </div>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-muted text-sm">
                  <span className="text-info mr-2 font-weight-bold">100% On-Time</span>
                  <span>Guide direct payments</span>
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Transactions Table Card */}
        <Row>
          <div className="col">
            <Card className="shadow border-0">
              <CardHeader className="border-0 d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
                <div>
                  <h3 className="mb-0 text-primary-new font-weight-bold">
                    Payments & Revenue Management
                  </h3>
                  <small className="text-muted">
                    Track guide subscriptions ($9.99/mo, $99.99/yr), featured placements, business ads & direct tours
                  </small>
                </div>
                <div className="d-flex flex-wrap align-items-center gap-2 mt-3 mt-md-0">
                  <InputGroup className="input-group-alternative" style={{ width: "240px" }}>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <FaSearch className="text-muted" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Search txn ID, user, invoice..."
                      type="text"
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                  </InputGroup>

                  <Input
                    type="select"
                    style={{ width: "180px" }}
                    value={typeFilter}
                    onChange={(e) => {
                      setTypeFilter(e.target.value);
                      setCurrentPage(1);
                    }}
                    className="custom-select"
                  >
                    <option value="all">All Revenue Types</option>
                    <option value="subscription">Subscriptions ($9.99 / $99.99)</option>
                    <option value="direct">Direct Tour Payments</option>
                    <option value="featured">Featured Guide Placements</option>
                    <option value="advertising">Local Business Ads</option>
                    <option value="badge">Verified Pro Badges</option>
                  </Input>

                  <Input
                    type="select"
                    style={{ width: "140px" }}
                    value={statusFilter}
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                      setCurrentPage(1);
                    }}
                    className="custom-select"
                  >
                    <option value="all">All Status</option>
                    <option value="completed">Completed</option>
                    <option value="refunded">Refunded</option>
                  </Input>
                </div>
              </CardHeader>

              {loading ? (
                <div className="py-5 text-center">
                  <LoadingDots message="Loading payments & revenue ledger..." />
                </div>
              ) : (
                <Table className="align-items-center table-flush" responsive hover>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Transaction ID</th>
                      <th scope="col">Payer / Guide</th>
                      <th scope="col">Revenue Type & Details</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Payment Method</th>
                      <th scope="col">Date</th>
                      <th scope="col">Status</th>
                      <th scope="col" className="text-right">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedTransactions.length > 0 ? (
                      paginatedTransactions.map((t) => (
                        <tr key={t.id}>
                          <td>
                            <span className="font-weight-bold text-primary">{t.id}</span>
                            <div className="small text-muted">{t.invoiceNumber}</div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <img
                                src={t.user.avatar}
                                alt={t.user.name}
                                className="avatar avatar-sm rounded-circle mr-2"
                              />
                              <div>
                                <span className="mb-0 text-sm font-weight-bold d-block">
                                  {t.user.name}
                                </span>
                                <small className="text-muted">{t.user.role} • {t.user.city}</small>
                              </div>
                            </div>
                          </td>
                          <td style={{ maxWidth: "240px" }}>
                            <span className="font-weight-bold text-dark d-block">
                              {t.revenueType}
                            </span>
                            <small className="text-muted text-truncate d-block">{t.planName}</small>
                          </td>
                          <td>
                            <span className="font-weight-bold text-success text-md">
                              ${t.amount.toFixed(2)}
                            </span>
                          </td>
                          <td>
                            <Badge color="light" className="p-2 border text-dark">
                              <FaCreditCard className="mr-1 text-primary" /> {t.paymentMethod}
                            </Badge>
                          </td>
                          <td>
                            <span className="text-sm font-weight-500">{t.date}</span>
                          </td>
                          <td>
                            {t.status === "completed" && (
                              <Badge color="success" className="badge-dot mr-4">
                                <i className="bg-success" /> Completed
                              </Badge>
                            )}
                            {t.status === "refunded" && (
                              <Badge color="warning" className="badge-dot mr-4">
                                <i className="bg-warning" /> Refunded
                              </Badge>
                            )}
                          </td>
                          <td className="text-right">
                            <UncontrolledDropdown>
                              <DropdownToggle
                                className="btn-icon-only text-light"
                                href="#pablo"
                                role="button"
                                size="sm"
                                color=""
                                onClick={(e) => e.preventDefault()}
                              >
                                <i className="fas fa-ellipsis-v" />
                              </DropdownToggle>
                              <DropdownMenu className="dropdown-menu-arrow" right>
                                <DropdownItem
                                  onClick={() => {
                                    setSelectedTxn(t);
                                    setReceiptModalOpen(true);
                                  }}
                                >
                                  <FaReceipt className="mr-2 text-primary" /> View Receipt
                                </DropdownItem>
                                <DropdownItem
                                  onClick={() => handleDownloadInvoice(t.invoiceNumber)}
                                >
                                  <FaDownload className="mr-2 text-success" /> Download Tax Invoice
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center py-4 text-muted">
                          No transactions found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              )}

              {/* Unified Pagination */}
              {!loading && filteredTransactions.length > 0 && (
                <CardFooter className="py-4 border-0">
                  <CustomPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalItems={filteredTransactions.length}
                    itemsPerPage={ITEMS_PER_PAGE}
                    onPageChange={(page) => setCurrentPage(page)}
                    itemName="transactions"
                  />
                </CardFooter>
              )}
            </Card>
          </div>
        </Row>

        {/* View Receipt Modal */}
        {selectedTxn && (
          <Modal
            isOpen={receiptModalOpen}
            toggle={() => setReceiptModalOpen(!receiptModalOpen)}
            size="md"
            centered
          >
            <ModalHeader
              toggle={() => setReceiptModalOpen(!receiptModalOpen)}
              className="bg-light border-bottom"
            >
              <div className="d-flex align-items-center">
                <FaReceipt className="text-primary mr-2" />
                <span className="font-weight-bold text-dark">
                  Transaction Receipt: {selectedTxn.id}
                </span>
              </div>
            </ModalHeader>
            <ModalBody className="p-4">
              <div className="text-center mb-4">
                <h2 className="font-weight-bold text-success mb-0">
                  ${selectedTxn.amount.toFixed(2)} USD
                </h2>
                <Badge color="success" className="mt-2">Payment Verified</Badge>
                <div className="small text-muted mt-1">{selectedTxn.date}</div>
              </div>

              <div className="border rounded p-3 bg-secondary mb-3">
                <Row className="mb-2">
                  <Col xs="5" className="text-muted">Invoice No:</Col>
                  <Col xs="7" className="font-weight-bold text-right">{selectedTxn.invoiceNumber}</Col>
                </Row>
                <Row className="mb-2">
                  <Col xs="5" className="text-muted">Account / User:</Col>
                  <Col xs="7" className="font-weight-bold text-right">{selectedTxn.user.name}</Col>
                </Row>
                <Row className="mb-2">
                  <Col xs="5" className="text-muted">Revenue Stream:</Col>
                  <Col xs="7" className="font-weight-bold text-right">{selectedTxn.revenueType}</Col>
                </Row>
                <Row className="mb-2">
                  <Col xs="5" className="text-muted">Item / Plan:</Col>
                  <Col xs="7" className="font-weight-bold text-right">{selectedTxn.planName}</Col>
                </Row>
                <Row className="mb-2">
                  <Col xs="5" className="text-muted">Payment Method:</Col>
                  <Col xs="7" className="font-weight-bold text-right">{selectedTxn.paymentMethod}</Col>
                </Row>
              </div>

              <div className="small text-muted text-center">
                Localmate Inc. • 100% Secure Encrypted Platform Payment
              </div>
            </ModalBody>
            <ModalFooter className="bg-light">
              <Button color="secondary" onClick={() => setReceiptModalOpen(false)}>
                Close
              </Button>
              <Button
                color="primary"
                onClick={() => handleDownloadInvoice(selectedTxn.invoiceNumber)}
              >
                <FaDownload className="mr-1" /> Download Invoice PDF
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </Container>
    </>
  );
};

export default PaymentsRevenue;
